import { createBackgroundLoaderContext } from "contexts";
import { CuratedTeacher } from "models";

export const CuratedContext = createBackgroundLoaderContext<CuratedTeacher>();
